"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ColorPicker_1 = require("./ColorPicker");
(function (w, $) {
    if (!$)
        return false;
    var colorPickerExtensions = {
        colorPicker: function () {
            return this.each(function () {
                var obj = $(this);
                new ColorPicker_1.ColorPicker(obj);
            });
        }
    };
    $.fn.extend(colorPickerExtensions);
})(window, $);
